
import './styles.css';
import InsaneTable from '../../component/insane-table';

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function MaintenanceStandardType() {

    let formList = [];

    HttpRequest("/admin/mt/form/get", {}).then(data => {
        // console.log("_form" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.mtresults.length; i++) {
                const _form = data.mtresults[i];
                formList.push({
                    displayName: _form.formcode + " (" +_form.formname + ")",
                    value: _form.formcode
                })
            }
        }
    });

    const tableOption = {
        tableName: "Standard Type",
        className: "",
        search: [
            {
                reqName: "standardid",
                displayName: "Standard ID",
                element: "input",
                placeholder: "Enter Standard ID."
            },
            {
                reqName: "formcode",
                displayName: "Formcode",
                placeholder: "Select Formcode.",
                element: "select",
                option: formList
            }
        ],
        mapTable: [
            {
                displayName: "Standard ID",
                attName: "standardid",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Standard Name",
                attName: "standardname",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Formcode",
                attName: "formcode",
                type: "text",
                form: {
                    validate: true,
                    element: "input",
                    option: formList
                }
            },
            {
                displayName: "Order",
                attName: "order",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Gas type",
                attName: "gastype",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Input value",
                attName: "input_value",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
            {
                displayName: "Output value",
                attName: "output_value",
                type: "text",
                form: {
                    validate: true,
                    element: "input"
                }
            },
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/mt/standard/get",
                dataReq: {
                    "index": 0,
                    "count": 10
                }
            },
            insert: {
                enable: false,
                url: "/admin/mt/standard/update",
                dataReq: {}
            },
            update: {
                enable: false,
                url: "/admin/mt/standard/update",
                dataReq: {}
            },
            delete: {
                enable: false,
                url: "/admin/mt/standard/delete",
                dataReq: {}
            }
        },
        action: [
            // {
            //     name: "Usage Log",
            //     mode: "page", /// page, modal, form
            //     option: {
            //         url: "/d-rec-admin/main/maintenance/standard-gas/log"
            //     }
            // }
        ]
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Standard Type.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default MaintenanceStandardType;